import React from 'react';
import { Navigate } from 'react-router-dom';
import NotFound from "../components/NotFound";

const ProtectedRoute = ({ element: Element, authenticated, role, requiredRole }) => {
    
    return authenticated ? (
        (role === requiredRole || !requiredRole) ? (
            <Element />
        ) : (
            <NotFound />
        )
    ) : (
        <Navigate to="/login" />
    );
};

export default ProtectedRoute;
